import { TriangleAlert as WarningIcon } from 'lucide-react';
import { useNetwork } from '../../context/NetworkContext';

export function NetworkBanner() {
  const { isOffline, retry } = useNetwork();

  if (!isOffline) return null;

  return (
    <div className="flex items-center justify-center gap-3 bg-amber-500 px-4 py-2 text-sm font-medium text-white">
      <WarningIcon className="h-4 w-4 flex-shrink-0" />
      <span>Connection lost. Retrying...</span>
      <button
        onClick={retry}
        className="rounded bg-amber-600 px-2 py-0.5 text-xs font-semibold hover:bg-amber-700"
      >
        Retry Now
      </button>
    </div>
  );
}
